import React, { Component } from "react";
import Slider from "react-slick";
import EventCard from "./../events/events";
import MainEvent from "./../../../main/comp/eventcard";
import PartnerCard from "../../../partner/cards/partner";
import MPCard from "../../../mp/comp/slidercard";


export default class Responsive extends Component {
    render() {
        const settings = {
            dots: true,
            arrows: false,
            infinite: false, // to stop duplicates from appearing at end of slider deck
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                breakpoint: 1200,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
                {
                breakpoint: 800,
                settings: {
                    dots: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
            ]
        };

        if (this.props.type === "main") {
            return (
                <div>
                    <Slider {...settings}>
                        {
                            this.props.arr.map((element, index) => {
                                return <MainEvent key={index} title={element[0]} desc={element[1]} date={element[2]} />
                            })
                        }
                    </Slider>
                </div>
            )
        }

        if (this.props.type === "events") {
            return (
                <div>
                    <Slider {...settings}>
                        {this.props.arr.map((event, index) => (
                            <EventCard
                                key={index}
                                title={event[0]}
                                desc={event[1]}
                                date={event[2]}
                                image={event[3]}
                                link={event[4]}
                            />
                        ))}
                    </Slider>
                </div>
            );
        }

        if (this.props.type === "mp") {
            return (
                <div>
                    <Slider {...settings}>
                        {
                            this.props.arr.map(element => {
                                return <MPCard title={element[0]} desc={element[1]} date={element[2]} />
                            })
                        }
                    </Slider>
                </div>
            )
        }

        if (this.props.type === "partners") {
            return (
                <div>
                    <Slider {...settings}>
                        {
                            this.props.arr.map(element => {
                                return <PartnerCard link={element[0]} image={element[1]} name={element[2]} company={element[3]} position={element[4]} />
                            })
                        }
                    </Slider>
                </div>
            )
        }
    }
}